
import { Options, prop, Vue } from "vue-class-component";

class Props {
  modelValue = prop<any>({
    required: true,
  });
}
@Options({
  emits: ["update:modelValue"],
})
class ClientBranchSection extends Vue.with(Props) {
  get deliveryOrderPaymentType() {
    return this.modelValue?.match(/free/g)
      ? this.$t("clientManagement.registrationBranchForm.deliveryOrderReturn.free").toString()
      : this.$t("clientManagement.registrationBranchForm.deliveryOrderReturn.paid").toString();
  }

  get dOOptions() {
    return [
      {
        name: this.$t("clientManagement.registrationBranchForm.deliveryOrderReturn.free").toString(),
        value: "free",
      },
      {
        name: this.$t("clientManagement.registrationBranchForm.deliveryOrderReturn.paid").toString(),
        value: "paid",
      },
    ];
  }
  onSelectDO(option: any) {
    this.$emit("update:modelValue", option.value);
  }
}
export default ClientBranchSection;
